import styled from "styled-components";

export const EncourageRegisterMemberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0 16px 0;
  background-color: #fff8d3;
  width: 100%;
`;

export const EncourageRegisterMemberImage = styled.img`
  width: 90%;
  margin: 4% 0;
`;
